export default {
    blueprintEdit: 'Edit',
    blueprint: 'BluePrint',
    export: 'Export',
    template_general: 'Allgemein',
    templates: 'Templates',
    regex: 'Regex',
    share: 'Share',
    gallery: 'Galerie',
    logs: 'Logs',
    projects_stats: 'Logs',
    cclights: 'CC LIGHT',
    appPanels: 'APP PANEL',
    sfxdata_meta_data: 'Meta Infos',
    font: 'Schrift',
    profiles: 'Profile',
    exportprofiles: 'Profile',
    exportprofiles_general: 'Allgemein',
    projects_preview: '3D Web-Ansicht',
    organizations_overview: 'Organisationen',
    organizations_add: 'Organisationen',
    organization: 'Organisation',
    organization_dashboard: 'Dashboard',
    help: 'Hilfe',
    texture: 'Textur',
    texture_general: 'Allgemein',
    texturebackbutton: 'Zurück',
    blueprintsbackbutton: 'Zurück',
    add_texture: 'Textur hinzufügen',
    projects_details: 'Share',
    projects_gallery: 'Galerie',
    projects_home: 'Home',
    versions: 'Versionen',
    instance: 'Instanz',
    instance_general: 'Allgemein',
    costOverview: 'Kosten',
    saasServices: 'SAAS SERVICES',
    saasAgb: 'SAAS AGB',
    csv_import: 'CSV Import',
    createVirtualMachine: 'VM erstellen',
    vmOverview: 'VM Übersicht',
    vmUsageAll: 'VM ALL',
    myVmUsage: 'VM Nutzung',
    vmUsage: 'VM Nutzung',
    adminproject: 'General Projects',
    taskmanager: 'Taskmanager',
    scene_general: 'Allgemein',
    scenebackbutton: 'Zurück',
    vmbackbutton: 'Zurück',
    scene: 'Szene',
    scenes: 'Szenen',
    service_edit: 'Allgemeines',
    rolebackbutton: 'Zurück',
    permissionsbackbutton: 'Zurück',
    permission_edit: 'Allgemeines',
    permissions: 'Berechtigungen',
    roles: 'Rollen',
    material_general: 'Allgemeines',
    materials: 'Materialien',
    team_general: 'Allgemeines',
    teams: 'Teams',
    organizing: 'Struktur',
    qrcodes: 'QR-Codes',
    materialmappers: 'Material-Mapper',
    services: 'Services',
    materialbackbutton: 'Zurück',
    materialmapbackbutton: 'Zurück',
    servicebackbutton: 'Zurück',
    teambackbutton: 'Zurück',
    sfxdata_export_profiles: 'Exportprofile',
    files: 'Dateien',
    library_files: 'Dateien',
    library_3d_files: 'Dateien',
    access_denied: 'Kein Zugriff',
    users: 'Benutzer',
    tags: 'Tags',
    admin: 'Admin',
    form_general: 'Allgemeines',
    formbackbutton: 'Zurück',
    projects: 'Projekte',
    project: 'Projekte',
    media: 'Medien',
    forms: 'Formulare',
    addMedia: 'Medien-Objekt erstellen',
    uploadMediaFile: 'Medien-Datei hochladen',
    logout: 'abmelden',
    apps: 'Applikationen',
    app: 'Applikationen',
    account: 'Benutzerkonto',
    organizations: 'Organisationen',
    Organization: 'Organisation',
    project_scene: "Szene",
    project_general: "Allgemeines",
    project_3ddata: "3D-Daten",
    project_media: 'Medien',
    project_datasets: "Datenquellen",
    project_datasources: "Datenquellen",
    report_general: "Allgemeines",
    sfxdata_general: "Allgemeines",
    sfxdata_general_assembly: "Allgemeines",
    sfxdata_data_sets: "Datenquellen",
    sfxdata_media: "Medien",
    sfxdata: "3D-Daten",
    app_general: "Allgemeines",
    media_general: "Allgemeines",
    font_general: "Allgemeines",
    user_general: "Allgemeines",
    app_project: "Projekt",
    data: "Daten",
    data_tables: "Tabellen",
    data_sources: "Datenquellen",
    datasources: "Datenquellen",
    data_sources_general: "Allgemeines",
    datasets: "Tabellen",
    dataset_general: "Allgemeines",
    resources: "Resourcen",
    library: "Bibliothek",
    reports: "Statistiken",
    report: "Statistiken",
    modelbackbutton: "Zurück",
    assemblybackbutton: "Zurück",
    reportbackbutton: "Zurück",
    projectsbackbutton: "Zurück",
    projectbackbutton: "Zurück",
    appbackbutton: "Zurück",
    webappbackbutton: "Zurück",
    sfxbackbutton: "Zurück",
    mediabackbutton: "Zurück",
    userbackbutton: "Zurück",
    datasetbackbutton: "Zurück",
    datasourcebackbutton: "Zurück",
    metasetbackbutton: "Zurück",
    textbackbutton: "Zurück",
    organizationbackbutton: "Zurück",
    qrcodebackbutton: "Zurück",
    materialmapperbackbutton: "Zurück",
    sfxdata_linked_data: "Verknüpfte 3D-Daten",
    texts: "Texte",
    text_general: "Allgemein",
    qrcode_general: "Allgemein",
    materialmapper_general: "Allgemein",
    project_linked_data: "Verknüpfte Daten",
    sfxdata_connection_list: "Alle Verknüpfungen",
    sfxdata_assembly_update: "Update",
    addnew3ddata: "Neues 3D-Objekt",
    Upload: "Datei hochladen",
    Config: "Konfiguration",
    metasets: "Metasets",
    metaSets: "Metasets",
    webapp_linked_data: "Verknüpfte Daten",
    zipExport: 'Zip Export',
    licenseOverview: 'Lizenzübersicht'
}